import { ppq } from "@teamprevent/common";

import { PpqAction } from "./actions";
import { LOAD_PPQ_REPORT_SUCCESS } from "./actionTypes";

export const ppqReports = (state: ppq.PpqReportModel[] = [], action: PpqAction): ppq.PpqReportModel[] => {
    switch (action.type) {
        case LOAD_PPQ_REPORT_SUCCESS: {
            return [...state.filter(r => r.viewTaskId !== action.payload.viewTaskId), action.payload];
        }
        default: {
            return state;
        }
    }
};
